import React from 'react';
import { Redirect } from 'react-router-dom';

//Main Landing Page
import iTSolutionTwo from '../pages/ITSolutionTwo/index';

const routes = [
  //Index Main
  { path: '/', component: iTSolutionTwo, isTopbarDark: true, isWithoutLayout: true },
];

export default routes;
